import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const hrmsSupabaseUrl = process.env.REACT_APP_HRMS_SUPABASE_URL;
const hrmsSupabaseAnonKey = process.env.REACT_APP_HRMS_SUPABASE_ANON_KEY;

if (
  !supabaseUrl ||
  !supabaseAnonKey ||
  !hrmsSupabaseUrl ||
  !hrmsSupabaseAnonKey
) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export const hrmsSupabase = createClient(hrmsSupabaseUrl, hrmsSupabaseAnonKey);
